/**
 * transformSurveyGPT
 * @param {Object} response
 * @param {boolean} response.active
 * @param {number} response.id
 * @param {string} response.output
 * @param {string} response.status
 * @param {string} [response.status_message] supplied when an error occurs
 * @param {boolean} [response.user_left_feedback]
 * @param {boolean} [response.user_left_negative_feedback]
 * @return {Object}
 */
export const transformSurveyGPT = ({
  active: isActive,
  id,
  output,
  status,
  status_message: statusMessage,
  user_left_feedback: userLeftFeedback,
  user_left_negative_feedback: userLeftNegativeFeedback,
}) => ({
  id,
  isActive,
  output,
  status,
  statusMessage,
  userLeftFeedback,
  userLeftNegativeFeedback,
});
